<template>
  <ul class="course-list">
    <li
      v-for="(item, index) in list"
      :key="index"
      class="course"
      @click="linkToCourseDetail(item.setId)"
    >
      <div
        class="cover-img"
        :style="{ backgroundImage: `url(${item.coverImagUrl})` }"
      ></div>
      <div class="course-right">
        <div class="title">{{ item.title }}</div>
        <div class="count">
          更新至第{{ item.courseCount }}节 | 已售{{ item.saledCount }}份
        </div>
        <div>
          <span class="price">￥{{ item.price }}/套 </span>
          <span class="original-price">原价￥{{ item.originalPrice }}</span>
          <el-button v-if="showButton" class="button-buy">购买</el-button>
        </div>
      </div>
    </li>
    <li v-show="!end" class="more" @click="loadMore">点击查看更多</li>
  </ul>
</template>

<script>
export default {
  name: 'CourseList',
  props: {
    list: {
      type: Array,
      required: true
    },
    end: {
      type: Boolean,
      default: true
    },
    showButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    },
    linkToCourseDetail(setId) {
      this.$router.push(`/course/${setId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.course {
  display: flex;
  align-items: center;
  height: 160px;
  position: relative;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
  transition: background-color 0.3s linear;

  &:hover {
    background-color: #fafafa;
  }

  .cover-img {
    width: 160px;
    height: 120px;
    background: no-repeat center;
    background-size: cover;
  }

  .title {
    font-size: 20px;
    line-height: 40px;
    color: #262626;
    transition: color 0.3s;
    text-decoration: none;

    &:hover {
      color: #046bcc;
    }
  }

  .count {
    font-size: 16px;
    line-height: 40px;
    letter-spacing: 1px;
    color: #858585;
  }

  .course-right {
    padding-left: 20px;
  }

  .price {
    font-size: 20px;
    line-height: 40px;
    color: #e64c2e;
  }

  .original-price {
    position: relative;
    font-size: 14px;
    color: #858585;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      height: 1px;
      background-color: #858585;
    }
  }
  .button-buy {
    width: 90px;
    position: absolute;
    line-height: 30px;
    margin-left: 20px;
    right: 10px;
    background-color: #e64c2e;
    border-radius: 2px;
    font-size: 16px;
    color: #ffffff;
    padding: 0;
    border: none;
  }
}

.more {
  width: 828px;
  height: 40px;
  margin: 30px auto;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}
</style>
